import React, { useState } from "react";
import { FaPlus, FaSearch, FaUser, FaBuilding } from "react-icons/fa";
import "./WhatsAppChat.css";

const ChatList = ({
  conversations = [],
  activeConversationId,
  onSelectConversation,
  searchQuery,
  onSearchChange,
  onOpenNewChat,
}) => {
  const [activeFilter, setActiveFilter] = useState("all"); // 'all', 'crm', 'leads', 'unread'

  const filteredConversations = conversations.filter((conv) => {
    // 1. Text Search Filter
    const contactName = conv.contact?.name || "";
    const phone = conv.contact?.phone || "";
    const crmName = conv.crm_customer?.customer_name || "";
    const crmCode = conv.crm_customer?.customer_code || "";
    const lastMsg = conv.last_message_body || "";
    const q = (searchQuery || "").toLowerCase();

    const matchesSearch =
      !q ||
      contactName.toLowerCase().includes(q) ||
      phone.includes(q) ||
      crmName.toLowerCase().includes(q) ||
      crmCode.toLowerCase().includes(q) ||
      lastMsg.toLowerCase().includes(q);

    if (!matchesSearch) return false;

    // 2. Category Filter
    if (activeFilter === "crm") {
      return conv.crm_customer?.is_linked === true;
    }
    if (activeFilter === "leads") {
      return !conv.crm_customer?.is_linked;
    }
    if (activeFilter === "unread") {
      return (conv.unread_count || 0) > 0;
    }
    return true;
  });

  const formatTimestamp = (dateStr) => {
    if (!dateStr) return "";
    try {
      const d = new Date(dateStr);
      const now = new Date();
      const isToday = d.toDateString() === now.toDateString();
      if (isToday) {
        return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
      }
      return d.toLocaleDateString([], { month: "short", day: "numeric" });
    } catch {
      return "";
    }
  };

  const getInitials = (name, phone) => {
    if (name && name.trim()) {
      const parts = name.trim().split(" ");
      if (parts.length >= 2) return `${parts[0][0]}${parts[1][0]}`.toUpperCase();
      return name.slice(0, 2).toUpperCase();
    }
    if (phone) return phone.slice(-2);
    return "WA";
  };

  return (
    <div className="rekonic-conversations-sidebar">
      {/* Top Section */}
      <div className="rekonic-sidebar-top">
        <div className="rekonic-sidebar-title-row">
          <h3 className="rekonic-sidebar-title">Conversations</h3>
          <button className="rekonic-btn-new-chat" onClick={onOpenNewChat} title="Start new WhatsApp chat">
            <FaPlus /> New Chat
          </button>
        </div>

        {/* Search */}
        <input
          type="text"
          className="rekonic-search-input"
          placeholder="Search by name, phone, or code..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />

        {/* Filter Pills */}
        <div className="rekonic-filter-pills">
          <button
            className={`rekonic-filter-pill ${activeFilter === "all" ? "active" : ""}`}
            onClick={() => setActiveFilter("all")}
          >
            All ({conversations.length})
          </button>
          <button
            className={`rekonic-filter-pill ${activeFilter === "crm" ? "active" : ""}`}
            onClick={() => setActiveFilter("crm")}
          >
            CRM Customers
          </button>
          <button
            className={`rekonic-filter-pill ${activeFilter === "leads" ? "active" : ""}`}
            onClick={() => setActiveFilter("leads")}
          >
            New Leads
          </button>
          <button
            className={`rekonic-filter-pill ${activeFilter === "unread" ? "active" : ""}`}
            onClick={() => setActiveFilter("unread")}
          >
            Unread
          </button>
        </div>
      </div>

      {/* Conversation List */}
      <div className="rekonic-chat-list">
        {filteredConversations.length === 0 ? (
          <div style={{ padding: "30px 20px", textAlign: "center", color: "#94a3b8", fontSize: "13px" }}>
            No conversations found
          </div>
        ) : (
          filteredConversations.map((conv) => {
            const isCrm = conv.crm_customer?.is_linked;
            const displayName =
              conv.crm_customer?.customer_name ||
              conv.contact?.name ||
              conv.contact?.phone ||
              "WhatsApp Contact";
            const phone = conv.contact?.phone || "";
            const isActive = conv.id === activeConversationId;
            const initials = getInitials(displayName, phone);

            return (
              <div
                key={conv.id}
                className={`rekonic-chat-item ${isActive ? "active" : ""}`}
                onClick={() => onSelectConversation(conv)}
              >
                <div className={`rekonic-avatar-wrap ${isCrm ? "is-crm" : ""}`}>
                  {initials}
                </div>

                <div className="rekonic-chat-info">
                  <div className="rekonic-chat-header-row">
                    <span className="rekonic-chat-name">
                      {displayName}
                      {isCrm ? (
                        <span className="rekonic-crm-badge" title={`CRM Code: ${conv.crm_customer?.customer_code || ""}`}>
                          CRM
                        </span>
                      ) : (
                        <span className="rekonic-lead-badge">Lead</span>
                      )}
                    </span>
                    <span className="rekonic-chat-time">
                      {formatTimestamp(conv.last_message_at)}
                    </span>
                  </div>

                  <div className="rekonic-chat-sub-row">
                    <span className="rekonic-chat-last-msg">
                      {conv.last_message_body || phone || "No message yet"}
                    </span>
                    {(conv.unread_count || 0) > 0 && (
                      <span className="rekonic-unread-badge">
                        {conv.unread_count}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })
        )}
      </div>
    </div>
  );
};

export default ChatList;
